import React, { Component } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import ToggleBtn from '../shared/toggleBtn';

import Switch from "react-switch";

/* Images */
import wakanda1 from '../../assets/wakanda1.jpg';
import wakanda3 from '../../assets/wakanda3.jpg';
import wakanda6 from '../../assets/wakanda6.jpg';

/* Add Title */
class AddTitle extends Component{
    constructor(props) {
        super(props);

        // Reference
        this.payDtRef = React.createRef();
        this.clickRef = this.clickRef.bind(this);
    }

    clickRef(refName){
        try {
            this[refName].current.setFocus();
        }
        catch(ex){
            console.log(" [Error] Selecting Reference: ",ex);
        }
    }

    componentDidMount(){}

    render(){        
        return(
            <div className="add-title">
                <div className="add-input btn-container">
                    <div className="title-text">Generate Budget</div>
                    {/* Name */}
                    <div className="tro-btn tro-input sz-5">
                        <input value={this.props.budgetCreate.name} name="name" placeholder="Name" autoComplete="off" onChange={this.props.handleChange} />
                        <div className="btn-icon"><i className="fas fa-signature" /></div>
                    </div>

                    {/* Pay Amount */}
                    <div className="tro-btn tro-input sz-4">
                        <input value={this.props.budgetCreate.payAmount} name="payAmount" type="number" placeholder="Pay Amount" onChange={this.props.handleChange} />
                        <div className="btn-icon"><i className="fas fa-dollar-sign" /></div>
                    </div>

                    {/* Pay Date */}
                    <div className="tro-btn tro-input sz-4">
                        <DatePicker selected={this.props.budgetCreate.payDt} placeholderText="Next Pay Date" ref={this.payDtRef} onChange={this.props.handleChange} />
                        <div className="btn-icon" onClick={()=> this.clickRef("payDtRef")}><i className="far fa-calendar-alt" /></div>
                    </div>

                    {/* Pay Freq */}
                    <div className="toggle-input tro-input sz-2">
                        <ToggleBtn toggles={["weekly","biweekly"]} selected={this.props.budgetCreate.freq} name="freq" handleChange={this.props.handleChange}/>
                    </div>
                    
                    {/* Save Percent */}
                    <div className="tro-btn tro-input sz-3">
                        <input value={this.props.budgetCreate.savePercent} name="savePercent" type="number" autoComplete="off" placeholder="Save Percent" onChange={this.props.handleChange} />
                        <div className="btn-icon"><i className="fas fa-piggy-bank" /></div>
                    </div>
                </div>
            </div>
        );
    }
}

/* Add Title */
class UpdateTitle extends Component{
    constructor(props) {
        super(props);

        this.styleAmount = this.styleAmount.bind(this);
    }

    styleAmount(data, type){
        var ret = data;
        try {
            if(type === "currency"){
                ret = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(data);
            }
            else if(type === "date"){
                var tmpDate = new Date(data);
                var dayStr = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
                var mthStr = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

                ret = dayStr[tmpDate.getDay()] + ". "+ mthStr[tmpDate.getMonth()] + " "+ tmpDate.getDate() + ", " + tmpDate.getFullYear(); 
            }
            
        }
        catch(ex){
            console.log(" [Error] Styling Amount: ", ex);
        }
        return ret;
    }

    componentDidMount(){}

    render(){        
        return(
            <div className="update-title">
                <div className="subtitle-text">
                    <span>{this.props.budgetActive.name}</span>
                    
                    {this.props.budgetActive._id == null && <i className="sub-icon far fa-save" onClick={this.props.saveBudget}/> }
                    <i className="sub-icon far fa-edit" onClick={() => this.props.activateSlider(true, "budget")}/>
                    <i className="sub-icon fas fa-times" />
                </div>
                <div className="title-text">{this.styleAmount(this.props.budgetActive.payAmount, "currency")}</div>
                <div className="update-content">
                    <div className="content-section">
                        <div className="section-title">Next Pay Date</div>
                        <div className="section-info">{this.styleAmount(this.props.budgetActive.payDt, "date")}</div>
                    </div>

                    <div className="content-section">
                        <div className="section-title">Frequency</div>
                        <div className="section-info">{this.props.budgetActive.freq}</div>
                    </div>

                    <div className="content-section">
                        <div className="section-title">Save Percent</div>
                        <div className="section-info">{this.props.budgetActive.savePercent}%</div>
                    </div>
                </div>
            </div>
        );
    }
}

/* Add Body */
class AddBody extends Component {
    constructor(props) {
        super(props);

        this.styleAmount = this.styleAmount.bind(this);
        this.getBillImg = this.getBillImg.bind(this);
    }

    styleAmount(number){
        var ret = number;
        try {
            ret = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(number);
        }
        catch(ex){
            console.log(" [Error] Styling Amount: ", ex);
        }
        return ret;
    }

    getBillImg(id){
        try {
            var tmpId = id % 3;
            switch(tmpId){
                case 0:
                    return wakanda1;
                case 1:
                    return wakanda3;
                case 2:
                    return wakanda6;
                default:
                    return wakanda1;
            }
        }
        catch(ex){
            console.log(" [Error] Getting Bill Img: ", ex);
            return wakanda1;
        }        
    }

    componentDidMount(){ }

    render(){        
        return(
            <div className="add-body">
                <div className="btn-container">
                    <div className="tro-btn btn" onClick={() => this.props.editBill("bill", null, -2)}>
                        <div className="btn-txt">Add Bill</div>
                        <div className="btn-icon"><i className="fas fa-file-invoice-dollar" /></div>
                    </div>
                    <div className="tro-btn btn" onClick={this.props.generateBudget}>
                        <div className="btn-txt">Generate</div>
                        <div className="btn-icon"><i className="fas fa-university" /></div>
                    </div>
                </div>

                <div className="bill-list">
                    {this.props.budgetCreate.billList.length === 0 && <div className="no-data">No Bills Currently Added</div>}
                    {this.props.budgetCreate.billList.map((item,i) =>
                        <div className="bill-line-item" key={i}>
                            <div className="line-section date">{item.payDt}</div>
                            <div className="line-section base">
                                <div className="sub-line name">{item.name}</div>
                                <div className="sub-line info">
                                    <div className="info-item">
                                        <span className="info-icon"><i className="fas fa-dollar-sign" /></span>
                                        <span className="info-text">{this.styleAmount(item.amount)}</span>
                                    </div>

                                    {item.flexible && <div className="info-item info-btn">Flexible</div>}
                                    <div className="info-item info-btn">{item.gracePeriod} Day Grace</div>
                                </div>
                            </div>
                            <div className="line-section img">
                                <img src={this.getBillImg(i)} />
                            </div>
                            <div className="line-section btn-list">
                                <div className="line-btn" onClick={() => this.props.editBill("bill", item, -2)}><i className="far fa-edit" /></div>
                                <div className="line-btn" onClick={() => this.props.removeBill(item.id)}><i className="fas fa-times" /></div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

/* Update Body */
class UpdateBody extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedPayment: {},
            selectedBucket: {},
            messageStatus: true
        }

        this.styleAmount = this.styleAmount.bind(this);
        this.getBucket = this.getBucket.bind(this);
        this.getBillImg = this.getBillImg.bind(this);
    }

    getBillImg(id){
        try {
            var tmpId = id % 3;
            switch(tmpId){
                case 0:
                    return wakanda1;
                case 1:
                    return wakanda3;
                case 2:
                    return wakanda6;
                default:
                    return wakanda1;
            }
        }
        catch(ex){
            console.log(" [Error] Getting Bill Img: ", ex);
            return wakanda1;
        }        
    }

    styleAmount(data, type){
        var ret = data;
        var dayStr = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
        var mthStr = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        var tmpDate;

        try {
            if(type === "currency"){
                ret = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(data);
            }
            else if(type === "date"){
                tmpDate = (data !== undefined ? new Date(data) : new Date());
                ret = dayStr[tmpDate.getDay()] + ". "+ mthStr[tmpDate.getMonth()] + " "+ tmpDate.getDate() + ", " + tmpDate.getFullYear(); 
            }
            else if(type === "month"){
                tmpDate = (data !== undefined ? new Date(data) : new Date());
                ret = mthStr[tmpDate.getMonth()];
            }
            else if(type === "day"){
                tmpDate = (data !== undefined ? new Date(data) : new Date());
                ret = tmpDate.getDate();
            }
            
        }
        catch(ex){
            console.log(" [Error] Styling Amount: ", ex);
        }
        return ret;
    }

    getBucket(payment){
        try {
            var tmpBucket = (payment.billCycleId === -1 ? [] : this.props.budgetActive.buckets.filter(function(item){ return item.date === payment.billCycleId; }));
            var tmpMsgStatus = true;

            if(tmpBucket.length > 0) {
                tmpBucket = tmpBucket[0];
                tmpBucket.billList = tmpBucket.billList.sort(function(a,b){ return a.payDt - b.payDt; });
                tmpMsgStatus = (tmpBucket.billList.filter(function(item){ return parseInt(payment.billCycleId,10) > parseInt(item.payDt,10); }).length > 0);
            }
            else { tmpBucket = {}; }

            this.setState({ selectedPayment:payment, selectedBucket: tmpBucket, messageStatus: tmpMsgStatus });
        }
        catch(ex){
            console.log(" [Error] getting bucket: ",ex);
        }
    }

    componentDidMount(){ 
        if(this.props.budgetActive.payments.length > 0){
            this.getBucket(this.props.budgetActive.payments[0]);
        }        
    }

    render(){        
        return(
            <div className="update-body">
                <div className="date-path page-panel">
                    {this.props.budgetActive.payments.map((item,i) =>
                        <div className="date-container" key={i} onClick={() => this.getBucket(item)}>
                            <div className="date-selector" />
                            <div className={"date-info" + (this.state.selectedPayment.payDt === item.payDt ? " sel":"")}>
                                <span className="cycle-id">{item.billCycleId}</span>
                                <span className="cycle-date">{this.styleAmount(item.payDt, "date")}</span>
                            </div>
                        </div>
                    )}
                </div>
                {this.state.selectedPayment.billCycleId == -1 && <div className="page-panel free-bucket">This Is A Free Check</div>}
                {this.state.selectedPayment.billCycleId > 0 &&
                    <div className="selected-bucket">
                        <div className="cycle-info">
                            <div className="cycle-date">
                                <div className="date-month">{this.styleAmount(this.state.selectedPayment.payDt, "month")}</div>
                                <div className="date-day">{this.styleAmount(this.state.selectedPayment.payDt, "day")}</div>
                            </div>

                            <div className="cycle-content bill">
                                <div className="content-title">Bill Total</div>
                                <div className="content-data">{this.styleAmount(this.state.selectedBucket.total, "currency")}</div>
                            </div>

                            <div className="cycle-content spend">
                                <div className="content-title">Free Spending</div>
                                <div className="content-data">{this.styleAmount(this.state.selectedBucket.spend, "currency")}</div>
                            </div>

                            <div className="cycle-content save">
                                <div className="content-title">Saving</div>
                                <div className="content-data">{this.styleAmount(this.state.selectedBucket.savings, "currency")}</div>
                            </div>

                            <div className="btn-container">
                                <div className="tro-btn btn" onClick={() => this.props.editBill("bill", null, this.state.selectedPayment.billCycleId)}>
                                    <div className="btn-txt">Add Bill</div>
                                    <div className="btn-icon"><i className="fas fa-file-invoice-dollar" /></div>
                                </div>
                            </div>
                        </div>
                        {this.state.messageStatus && 
                            <div className="update-message">
                                <div>To follow this optimization plan contact your bill companies & move </div>
                                <div>each of the following due dates to on or after day <span>{this.state.selectedPayment.billCycleId}</span> of the month</div>
                            </div>
                        }
                        <div className="bill-list">
                            {this.state.selectedBucket.billList.length === 0 && <div className="no-data">No Bills Currently Added</div>}
                            {this.state.selectedBucket.billList.map((item,i) =>
                                <div className="bill-line-item" key={i}>
                                    <div className="line-section date">{item.payDt}</div>
                                    <div className="line-section base">
                                        <div className="sub-line name">{item.name}</div>
                                        <div className="sub-line info">
                                            <div className="info-item">
                                                <span className="info-icon"><i className="fas fa-dollar-sign" /></span>
                                                <span className="info-text">{this.styleAmount(item.amount)}</span>
                                            </div>

                                            {item.flexible && <div className="info-item info-btn">Flexible</div>}
                                            <div className="info-item info-btn">{item.gracePeriod} Day Grace</div>
                                        </div>
                                    </div>
                                    <div className="line-section img">
                                        <img src={this.getBillImg(i)} />
                                    </div>
                                    <div className="line-section btn-list">
                                        <div className="line-btn" onClick={() => this.props.editBill("bill", item, this.state.selectedPayment.billCycleId)}><i className="far fa-edit" /></div>
                                        <div className="line-btn" onClick={() => this.props.removeBill(item.id, this.state.selectedPayment.billCycleId)}><i className="fas fa-times" /></div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                }
            </div>
        );
    }
}

/* Add / Update Slider */
class AddSlider extends Component{
    constructor(props) {
        super(props);
        this.state = {}

        this.saveBill = this.saveBill.bind(this);
    }

    saveBill(){
        try {
            var tmpBill = this.props.selectedBill;
            var tmpBucketId = this.props.selectedBucketId;
            if(tmpBill.id == null){
                tmpBill.id = Date.now();
                this.props.saveBill("create", tmpBill, tmpBucketId);
            }
            else {
                this.props.saveBill("update", tmpBill, tmpBucketId);
            }
            
            this.props.toggleSlider(false)
        }
        catch(ex){
            console.log(" [Error] Save Bill: ",ex);
        }
    }

    componentDidMount(){ }

    render(){        
        return(
            <div className="slider-input add">
                <div className="slider-title">
                    <span className="title-txt">Bill Edit</span>

                    <div className="btn-container">
                        <div className="tro-btn btn" onClick={this.saveBill}>
                            <div className="btn-txt">Save</div>
                            <div className="btn-icon"><i className="far fa-save" /></div>
                        </div>
                    </div>
                    <i className="title-icon fas fa-times" onClick={() => this.props.toggleSlider(false)}/>
                </div>

                <div className="input-field sz-5">
                    <span>Bill Name</span>
                    <input type="text" name="name" autoComplete="off" value={this.props.selectedBill.name} onChange={this.props.handleChange} />
                </div>

                <div className="input-field sz-4">
                    <span>Amount</span>
                    <input type="number" name="amount" autoComplete="off" value={this.props.selectedBill.amount} onChange={this.props.handleChange} />
                </div>

                <div className="input-field sz-3">
                    <span>Pay Date</span>
                    <input type="number" name="payDt" min="1" max="31" value={this.props.selectedBill.payDt} onChange={this.props.handleChange} />
                </div>

                <div className="input-field sz-3">
                    <span>Grace Period</span>
                    <input type="number" name="gracePeriod" min="1" max="30" value={this.props.selectedBill.gracePeriod} onChange={this.props.handleChange} />
                </div>

                <div className="input-field sz-3">
                    <span>Flexible</span>   
                    <Switch className="input-switch" id="flexible" height={20} checked={this.props.selectedBill.flexible} onChange={this.props.handleSwitchChange} />                           
                </div>
            </div>
        );
    }
}

/* Update Bucket Slider */
class UpdateBucketSlider extends Component{
    constructor(props) {
        super(props);
        this.state = {}

        this.saveBudget = this.saveBudget.bind(this);
    }

    saveBudget(){
        try {            
            this.props.toggleSlider(false);
        }
        catch(ex){
            console.log(" [Error] Save Bill: ",ex);
        }
    }

    componentDidMount(){ }

    render(){        
        return(
            <div className="slider-input bucket-slider">
                <div className="slider-title">
                    <span className="title-txt">Bucket Update</span>

                    <div className="btn-container">
                        <div className="tro-btn btn" onClick={this.props.generateBudget}>
                            <div className="btn-txt">Regenerate</div>
                            <div className="btn-icon"><i className="fab fa-rev" /></div>
                        </div>
                    </div>
                    <i className="title-icon fas fa-times" onClick={() => this.props.toggleSlider(false)}/>
                </div>

                <div className="input-field sz-5">
                    <span>Bucket Name</span>
                    <input type="text" name="name" autoComplete="off" value={this.props.selectedBudget.name} onChange={this.props.handleChange} />
                </div>

                <div className="input-field sz-4">
                    <span>Next Pay Date</span>
                    <DatePicker selected={this.props.selectedBudget.payDt} placeholderText="Next Pay Date" onChange={this.props.handleChange} />
                </div>

                <div className="input-field sz-3">
                    <span>Freqency</span>
                    <ToggleBtn toggles={["weekly","biweekly"]} selected={this.props.selectedBudget.freq} name="freq" handleChange={this.props.handleChange}/>
                </div>

                <div className="input-field sz-3">
                    <span>Save Percent</span>
                    <input type="number" name="savePercent" value={this.props.selectedBudget.savePercent} onChange={this.props.handleChange} />
                </div>
            </div>
        );
    }
}

export { AddTitle, UpdateTitle, AddBody, UpdateBody, AddSlider, UpdateBucketSlider };